<template>
  <div class="d-flex flex-row fill-height">

    <div class="filter-container pr-4">
        
        <div
            :class="{'d-block': shallFilterShadowBottom}"
            class="shadow-bottom">
        </div>
        
            <v-card flat>
                <v-card-title class="primary--text">Filter</v-card-title>
                <v-card-text class="pa-0">
                    
                    <div class=" norms-screen">
            <perfect-scrollbar
                :options="perfectScrollbarOptions"
                @ps-scroll-y="evt => { shallFilterShadowBottom = evt.srcElement.scrollTop > 0 }"
            >
                    <v-card>
                        <v-card-text>
                            <span>Share of Shelf</span>
                            <v-range-slider
                                v-model="shareOfShelf"
                                max="100"
                                min="1"
                                hide-details
                                class="align-center"
                                
                            >
                                <template v-slot:prepend>
                                    <v-text-field
                                        :value="shareOfShelf[0]"
                                        class="mt-0 pt-0"
                                        hide-details
                                        single-line
                                        type="number"
                                        style="width: 65px"
                                        dense
                                        outlined
                                        @change="$set(shareOfShelf, 0, $event)"
                                    ></v-text-field>
                                </template>
                                <template v-slot:append>
                                    <v-text-field
                                        :value="shareOfShelf[1]"
                                        class="mt-0 pt-0"
                                        hide-details
                                        single-line
                                        type="number"
                                        style="width: 65px"
                                        dense
                                        outlined
                                        @change="$set(shareOfShelf, 1, $event)"
                                    ></v-text-field>
                                </template>
                            </v-range-slider>
                        </v-card-text>
                    </v-card>
                    <v-divider class="ma-0"></v-divider>
                    <v-card flat tile>
                        <!-- <v-card-title class="py-1">Pack</v-card-title> -->
                        <v-card-text>
                            <v-switch 
                                v-model="evolutionVSCurrent"
                                label="Evolution vs Current"
                                hide-details
                            ></v-switch >
                        </v-card-text>
                    </v-card>
                    <v-divider class="ma-0"></v-divider>
                    <v-card flat tile>
                        <v-card-text class="pa-0 " v-if="countriesList">
                            <!-- Countries -->
                            <filter-component
                                filterName="Countries"
                                :itemList="countriesList"
                                :selectedItems="selectedCountries"
                                :initialCount="initialCountriesCount"
                                :loading="countriesLoading"
                                @update="filterChange"
                            ></filter-component>
                            <v-divider class="ma-0"></v-divider>
                            <!-- Categories -->
                            <filter-component
                                filterName="Categories"
                                :itemList="categoriesList"
                                :selectedItems="selectedCategories"
                                :initialCount="initialCategoriesCount"
                                :loading="categoriesLoading"
                                @update="filterChange"
                            ></filter-component>
                            <v-divider class="ma-0"></v-divider>
                            <!-- Brand -->

                            <filter-component
                                filterName="Brands"
                                :itemList="brandsList"
                                :selectedItems="selectedBrands"
                                :initialCount="initialBrandsCount"
                                :expand="1"
                                @update="filterChange"
                            ></filter-component>
                            <v-divider class="ma-0"></v-divider>
                            <!-- Client -->
                                
                            <filter-component
                                filterName="Clients"
                                :itemList="clientsList"
                                :selectedItems="selectedClients"
                                :initialCount="initialClientsCount"
                                :expand="1"
                                @update="filterChange"
                            ></filter-component>
                        </v-card-text>
                    </v-card>
                    <v-divider class="ma-0"></v-divider>
                
                    <v-card flat tile>
                        
                        <v-card-text class="pa-0 ">
                            <filter-component
                                filterName="Gender"
                                :itemList="genderList"
                                :selectedItems="selectedGenders"
                                :initialCount="7"
                                @update="filterChange"
                            ></filter-component>
                            <v-divider class="ma-0"></v-divider>
                            <filter-component
                                filterName="Frequencies"
                                :itemList="frequencyList"
                                :selectedItems="selectedFrequencies"
                                :initialCount="7"
                                @update="filterChange"
                            ></filter-component>
                        </v-card-text>
                    </v-card>
                    
        </perfect-scrollbar>  
        </div>  
                    <v-divider class="ma-0"></v-divider>
                    <v-card flat tile>
                        <v-card-text>
                            <a href="#" @click="isAdvFilterDialogOpen = true">Advanced Filters</a>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                text
                                class="pr-2"
                                @click="resetFilter"
                            >Reset</v-btn>
                            <v-btn
                                color="primary"
                                small
                                @click="fetchNorms"
                            >Apply</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card-text>
            </v-card>  
    </div>
    <div class="content-container" style="position: relative;">
        
                
        <v-card class="w-100">
            
        <v-overlay
              :absolute="true"
            :value="overlay"
            class="d-flex align-center"
            >
                <v-card
                    color="#036358"
                >
                <v-card-text>Filter updated! Norms might not be correctly reflected.
                    Please click apply! </v-card-text>
                    
                </v-card>
            </v-overlay>
            <v-card-title 
            >
                Norms
            </v-card-title>
            <v-card-text>
                
                <v-row class="pa-0">
                    <v-col cols="12" md="6">
                        <v-autocomplete
                        v-model="selectedS1"
                        :items="filtersS1"
                        label="System 1"
                        multiple
                        chips
                        dense
                        outlined
                        hide-details
                        small-chips
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete
                        v-model="selectedS2"
                        :items="filtersS2"
                        label="System 2"
                        multiple
                        chips
                        dense
                        outlined
                        hide-details
                        small-chips
                        ></v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            
            <v-card-text>
                <v-card flat :loading="qValueLoading">
                    <v-card-title v-if="normsLoaded">Value</v-card-title>
                    <v-card-text >
                        <div id="qValue-container"></div>
                    </v-card-text>
                </v-card>
                
                <v-card flat :loading="qPropensityLoading">
                    <v-card-title v-if="normsLoaded">Propensity to Buy</v-card-title>
                    <v-card-text>
                        <div id="qPropensityToBuy-container"></div>
                    </v-card-text>
                </v-card>
                <v-card flat :loading="flash3FitLoading">
                    <v-card-title v-if="normsLoaded">Flash 3 FIT</v-card-title>
                    <v-card-text>
                        <div id="flash3Fit-container"></div>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
  </div>
  <advanced-filter-component
    :is-adv-filter-dialog-open.sync="isAdvFilterDialogOpen"
  >

  </advanced-filter-component>
  </div>
</template>

<script>
import store from '@/store'
import { onUnmounted, ref, onMounted, computed, watch } from '@vue/composition-api'
import odbStoreModule from './odbStoreModule'
import useODB from './useODB'
import { over, value } from 'lodash-es'
// 3rd Party
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import FilterComponent from './FilterComponent.vue'
import AdvancedFilterComponent from './AdvancedFilterComponent.vue'

export default {
  components: {
    // 3rd Party
    PerfectScrollbar,
    FilterComponent,
    AdvancedFilterComponent
  },
    setup() {
        const ODB_APP_STORE_MODULE_NAME = 'app-odb'
        // Register module
        if (!store.hasModule(ODB_APP_STORE_MODULE_NAME)) store.registerModule(ODB_APP_STORE_MODULE_NAME, odbStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(ODB_APP_STORE_MODULE_NAME)) store.unregisterModule(ODB_APP_STORE_MODULE_NAME)
        })

        
        const perfectScrollbarOptions = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        }

        // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
        const shallFilterShadowBottom = ref(false)

        const shareOfShelf = ref([1,100])
        const evolutionVSCurrent = ref(false)

        const selectedGenders = ref([])
        const selectedFrequencies = ref([])
        
        const selectedCountries = ref([])
        const initialCountriesCount = ref(7)  // Number of countries to initially display
        
        const selectedCategories = ref([])
        const initialCategoriesCount = ref(7)  // Number of categories to initially display
        
        const selectedBrands = ref([])
        const initialBrandsCount = ref(7)  // Number of categories to initially display
        
        const selectedClients = ref([])
        const initialClientsCount = ref(7)  // Number of categories to initially display

        const overlay = ref(false)
        const normsLoaded = ref(false)

        const isAdvFilterDialogOpen = ref(false)

        
        const selectedS1 = ref([])
        const filtersS1 = ref([
            { text: 'Purchase Rate', value: 'Q_Value' },
            { text: '...', value: 'Q_PropensityToBuy' }
        ])
        
        
        const selectedS2 = ref(['Q_Value', 'F_FLASH3_FIT'])
        const filtersS2 = ref([
            { text: 'Value', value: 'Q_Value' },
            { text: 'Propensity to buy', value: 'Q_PropensityToBuy' },
            { text: 'Flash3 FIT', value: 'F_FLASH3_FIT' },
        ])
        
        const {
            genderList,
            frequencyList,
            qValue,
            qPropensityToBuy,
            flash3Fit,
            
            categoriesList,
            categoriesLoading,
            countriesList,
            countriesLoading,
            brandsList,
            brandsLoading,
            clientsList,
            clientsLoading,

            qValueLoading,
            qPropensityLoading,
            flash3FitLoading,
            fetchQValue,
            fetchQPropensityToBuy,
            fetchFlash3Fit,
            fetchCategories,
            fetchBrands,
            fetchCountries

        } = useODB()

        const fetchNorms = async () => {
            const share_of_shelf = shareOfShelf.value.join()
            const params = {
                gender: selectedGenders.value,
                frequency: selectedFrequencies.value,
                shareOfShelf: share_of_shelf,
                countries:selectedCountries.value,
                categories:selectedCategories.value,
                brands:selectedBrands.value,
                evolution_vs_current:evolutionVSCurrent.value
            }
            fetchQValue(params)
            fetchQPropensityToBuy(params)
            await fetchFlash3Fit(params)
            normsLoaded.value = true
            overlay.value = false
        }

        const filterChange = () => {
            overlay.value = true
        }

        const resetFilter = () => {
            overlay.value = false
            
            selectedGenders.value.length = 0
            selectedFrequencies.value.length = 0
            selectedCountries.value.length = 0
            selectedCategories.value.length = 0
            selectedBrands.value.length = 0
            selectedClients.value.length = 0
            
            countriesList.value.map(item => {
                item.selected = false
            })
            categoriesList.value.map(item => {
                item.selected = false
            })
            genderList.value.map(item => {
                item.selected = false
            })
            frequencyList.value.map(item => {
                item.selected = false
            })
            brandsList.value.map(item => {
                item.selected = false
            })
            clientsList.value.map(item => {
                item.selected = false
            })

            
        }

        onMounted(() => {
            
            fetchCategories()
            fetchCountries()
            fetchBrands()
        })

        return {
            shallFilterShadowBottom,

            shareOfShelf,
            evolutionVSCurrent,

            qValue,
            qValueLoading,

            qPropensityToBuy,
            qPropensityLoading,

            flash3Fit,
            flash3FitLoading,

            frequencyList,
            selectedFrequencies,
            
            genderList,
            selectedGenders,

            categoriesList,
            selectedCategories,
            initialCategoriesCount,
            categoriesLoading,
        
            countriesList,
            selectedCountries,
            initialCountriesCount,
            countriesLoading,
            
            brandsList,
            selectedBrands,
            initialBrandsCount,
            brandsLoading,

            clientsList,
            selectedClients,
            initialClientsCount,
            clientsLoading,
            
            filterChange,
            overlay,
            resetFilter,
            

            fetchNorms,
            normsLoaded,

            perfectScrollbarOptions,
            isAdvFilterDialogOpen,
            filtersS2,
            selectedS2,
            filtersS1,
            selectedS1,

        }
    
    }
}
</script>

<style>

.norms-screen {
    height: calc(100vh - 2*64px - 2*57px - 2*48px);
}

/* Main flex row layout */
.d-flex.flex-row.fill-height {
  height: calc(100vh - 64px - 57px - 48px); /* Make the container fill the viewport height (64px header 56px footer 48px 2*24px padding on main)*/
  overflow: hidden; /* Prevent the body from scrolling */
}

/* Left sidebar styles */
.filter-container {
  width: 270px; /* Set a fixed, smaller width for the left sidebar */
  flex-shrink: 0; /* Prevent the sidebar from shrinking */
  position:relative;
}

/* Perfect Scrollbar container styles */
.filter-container .ps {
  height: 100%; /* Make the perfect scrollbar fill the container height */
}


/* Right content styles */
.content-container {
  flex-grow: 1; /* Allow the main content to take up the remaining space */
  overflow-y: auto; /* Allow the main content area to scroll if needed */
}

/* Custom Perfect Scrollbar styling */
.ps__rail-y {
  width: 8px !important; /* Narrower scrollbar rail */
  opacity: 0.6;
}
.ps__thumb-y {
  width: 6px !important; /* Narrower scrollbar thumb */
  background-color: #9e9e9e !important; /* Custom color for the thumb */
}


 table {
      border-collapse: collapse;
      width: 100%;
      margin-bottom: 20px;
    }

    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
    }

    .green {
      background-color: #d4edda;
    }

    .blue {
      background-color: #cce5ff;
    }

    .orange {
      background-color: #fff3cd;
    }

    .red {
      background-color: #f8d7da;
    }
    .v-data-table .v-data-table__wrapper table tbody tr td,
    .v-data-table .v-data-table__wrapper table thead tr th {
      padding: 4px 8px; /* Adjust as needed */
    }
    
    .no-data {
      text-align: center;
      padding: 20px;
      font-style: italic;
      color: #888;
    }

.shadow-bottom {
    background: linear-gradient(#f4f5fa 40%, rgba(244, 245, 250, 0.1) 95%, rgba(244, 245, 250, 0.05));
    margin-top: -0.5rem;
    filter: blur(4px);
    box-sizing: border-box;
    display: none;
    position: absolute;
    z-index: 2;
    height: 50px;
    width: 100%;
    left: -6px;
    pointer-events: none;
    margin-top: -0.7rem;
    filter: blur(5px);
}
</style>

